var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('CookieConsentModal'),_c('ErrorMaintenance'),(_vm.socketDebugEnabled)?_c('SocketDebugOverlay'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }